// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1__eed4c0fbe26f76500553","cls2":"PaperSelector-cls2___1e12db6e820cf142a44 PaperSelector-cls1__eed4c0fbe26f76500553"};